/**
 * Activities & sports emoji category with searchable keywords
 */
export const activities = {
  name: 'Activities',
  icon: '⚽',
  emojis: [
    { emoji: '⚽', keywords: ['soccer', 'football', 'ball', 'sport', 'game'] },
    { emoji: '🏀', keywords: ['basketball', 'ball', 'sport', 'nba', 'hoop'] },
    { emoji: '🏈', keywords: ['football', 'american', 'nfl', 'sport', 'ball'] },
    { emoji: '⚾', keywords: ['baseball', 'ball', 'sport', 'mlb', 'game'] },
    { emoji: '🥎', keywords: ['softball', 'ball', 'sport', 'game', 'pitch'] },
    { emoji: '🎾', keywords: ['tennis', 'ball', 'sport', 'racket', 'game'] },
    { emoji: '🏐', keywords: ['volleyball', 'ball', 'sport', 'beach', 'game'] },
    { emoji: '🏉', keywords: ['rugby', 'ball', 'sport', 'football', 'game'] },
    { emoji: '🥏', keywords: ['frisbee', 'disc', 'flying', 'ultimate', 'sport'] },
    { emoji: '🎱', keywords: ['pool', 'billiards', 'ball', 'eight', 'game'] },
    { emoji: '🪀', keywords: ['yoyo', 'toy', 'string', 'skill', 'play'] },
    { emoji: '🏓', keywords: ['ping', 'pong', 'table', 'tennis', 'paddle'] },
    { emoji: '🏸', keywords: ['badminton', 'racket', 'shuttlecock', 'sport', 'game'] },
    { emoji: '🏒', keywords: ['hockey', 'ice', 'stick', 'puck', 'sport'] },
    { emoji: '🏑', keywords: ['hockey', 'field', 'stick', 'sport', 'game'] },
    { emoji: '🥍', keywords: ['lacrosse', 'stick', 'ball', 'sport', 'game'] },
    { emoji: '🏏', keywords: ['cricket', 'bat', 'ball', 'sport', 'game'] },
    { emoji: '🪃', keywords: ['boomerang', 'throw', 'return', 'australia', 'toy'] },
    { emoji: '🥅', keywords: ['goal', 'net', 'hockey', 'soccer', 'sport'] },
    { emoji: '⛳', keywords: ['golf', 'hole', 'flag', 'sport', 'course'] },
    { emoji: '🪁', keywords: ['kite', 'fly', 'wind', 'toy', 'sky'] },
    { emoji: '🏹', keywords: ['bow', 'arrow', 'archery', 'sport', 'target'] },
    { emoji: '🎣', keywords: ['fishing', 'pole', 'rod', 'fish', 'hobby'] },
    { emoji: '🤿', keywords: ['diving', 'mask', 'snorkel', 'swim', 'underwater'] },
    { emoji: '🥊', keywords: ['boxing', 'glove', 'punch', 'fight', 'sport'] },
    { emoji: '🥋', keywords: ['martial', 'arts', 'karate', 'judo', 'uniform'] },
    { emoji: '🎽', keywords: ['running', 'shirt', 'jersey', 'sport', 'race'] },
    { emoji: '🛹', keywords: ['skateboard', 'skate', 'board', 'trick', 'sport'] },
    { emoji: '🛼', keywords: ['roller', 'skate', 'skating', 'retro', 'sport'] },
    { emoji: '🛷', keywords: ['sled', 'sledge', 'snow', 'winter', 'slide'] },
    { emoji: '⛸️', keywords: ['ice', 'skate', 'skating', 'winter', 'sport'] },
    { emoji: '🥌', keywords: ['curling', 'stone', 'ice', 'winter', 'sport'] },
    { emoji: '🎿', keywords: ['ski', 'skiing', 'snow', 'winter', 'mountain'] },
    { emoji: '⛷️', keywords: ['skier', 'skiing', 'snow', 'winter', 'sport'] },
    { emoji: '🏂', keywords: ['snowboard', 'snowboarding', 'winter', 'snow', 'sport'] },
    { emoji: '🪂', keywords: ['parachute', 'skydive', 'jump', 'fall', 'sport'] },
    { emoji: '🏋️', keywords: ['weightlifting', 'gym', 'workout', 'strength', 'exercise'] },
    { emoji: '🤼', keywords: ['wrestling', 'sport', 'fight', 'grapple', 'match'] },
    { emoji: '🤸', keywords: ['cartwheel', 'gymnastics', 'flip', 'acrobat', 'sport'] },
    { emoji: '⛹️', keywords: ['basketball', 'dribble', 'bounce', 'sport', 'player'] },
    { emoji: '🤺', keywords: ['fencing', 'sword', 'sport', 'duel', 'epee'] },
    { emoji: '🤾', keywords: ['handball', 'throw', 'sport', 'ball', 'game'] },
    { emoji: '🏌️', keywords: ['golf', 'swing', 'club', 'sport', 'course'] },
    { emoji: '🏇', keywords: ['horse', 'racing', 'jockey', 'ride', 'sport'] },
    { emoji: '🏊', keywords: ['swim', 'swimming', 'pool', 'water', 'sport'] },
    { emoji: '🤽', keywords: ['water', 'polo', 'swim', 'sport', 'ball'] },
    { emoji: '🚣', keywords: ['rowing', 'boat', 'row', 'water', 'sport'] },
    { emoji: '🧗', keywords: ['climbing', 'rock', 'climb', 'mountain', 'sport'] },
    { emoji: '🚵', keywords: ['mountain', 'bike', 'cycling', 'biking', 'sport'] },
    { emoji: '🚴', keywords: ['cycling', 'bike', 'bicycle', 'ride', 'sport'] },
    { emoji: '🏆', keywords: ['trophy', 'winner', 'champion', 'award', 'first'] },
    { emoji: '🥇', keywords: ['gold', 'medal', 'first', 'winner', 'place'] },
    { emoji: '🥈', keywords: ['silver', 'medal', 'second', 'place', 'award'] },
    { emoji: '🥉', keywords: ['bronze', 'medal', 'third', 'place', 'award'] },
    { emoji: '🏅', keywords: ['medal', 'sports', 'award', 'achievement', 'winner'] },
    { emoji: '🎖️', keywords: ['military', 'medal', 'honor', 'award', 'badge'] },
    { emoji: '🏵️', keywords: ['rosette', 'award', 'flower', 'decoration', 'prize'] },
    { emoji: '🎗️', keywords: ['ribbon', 'awareness', 'reminder', 'support', 'cause'] },
    { emoji: '🎫', keywords: ['ticket', 'admission', 'event', 'pass', 'entry'] },
    { emoji: '🎟️', keywords: ['ticket', 'admission', 'event', 'movie', 'show'] },
    { emoji: '🎪', keywords: ['circus', 'tent', 'carnival', 'show', 'entertainment'] },
    { emoji: '🤹', keywords: ['juggling', 'circus', 'skill', 'balls', 'performance'] },
    { emoji: '🎭', keywords: ['theater', 'drama', 'masks', 'performing', 'arts'] },
    { emoji: '🎨', keywords: ['art', 'palette', 'paint', 'colors', 'creative'] },
    { emoji: '🎬', keywords: ['movie', 'film', 'clapper', 'action', 'cinema'] },
    { emoji: '🎤', keywords: ['microphone', 'sing', 'karaoke', 'music', 'voice'] },
    { emoji: '🎧', keywords: ['headphones', 'music', 'listen', 'audio', 'sound'] },
    { emoji: '🎼', keywords: ['music', 'score', 'notes', 'sheet', 'compose'] },
    { emoji: '🎹', keywords: ['piano', 'keyboard', 'music', 'keys', 'instrument'] },
    { emoji: '🥁', keywords: ['drum', 'music', 'beat', 'percussion', 'instrument'] },
    { emoji: '🪘', keywords: ['drum', 'long', 'music', 'percussion', 'african'] },
    { emoji: '🎷', keywords: ['saxophone', 'sax', 'jazz', 'music', 'instrument'] },
    { emoji: '🎺', keywords: ['trumpet', 'brass', 'music', 'horn', 'instrument'] },
    { emoji: '🪗', keywords: ['accordion', 'music', 'squeeze', 'instrument', 'polka'] },
    { emoji: '🎸', keywords: ['guitar', 'rock', 'music', 'electric', 'instrument'] },
    { emoji: '🪕', keywords: ['banjo', 'music', 'country', 'string', 'instrument'] },
    { emoji: '🎻', keywords: ['violin', 'fiddle', 'music', 'classical', 'instrument'] },
    { emoji: '🎲', keywords: ['dice', 'game', 'gamble', 'luck', 'roll'] },
    { emoji: '♟️', keywords: ['chess', 'pawn', 'game', 'strategy', 'board'] },
    { emoji: '🎯', keywords: ['target', 'bullseye', 'dart', 'aim', 'goal', 'direct', 'hit'] },
    { emoji: '🎳', keywords: ['bowling', 'ball', 'pins', 'sport', 'game'] },
    { emoji: '🎮', keywords: ['game', 'controller', 'video', 'gaming', 'play'] },
    { emoji: '🎰', keywords: ['slot', 'machine', 'casino', 'gamble', 'luck'] },
    { emoji: '🧩', keywords: ['puzzle', 'piece', 'jigsaw', 'game', 'solve'] },
  ],
};

export default activities;

